import { connect } from 'react-redux';
import { IRootAccountState } from '../models';
import { OrganizationCard } from './OrganizationCard';

export const mapStateToProps = (state: IRootAccountState) => {
  const homeTenantId = state.user.currentOrg && state.user.currentOrg.objectId;
  return {
    homeTenantId
  };
};

export const ConnectedOrganizationCard = connect(mapStateToProps)(OrganizationCard);
